// Internal modules
import { $logger } from '../../logger';
const isIframe = () => {
  return window.top !== window.self;
};

const isPopup = () => {
  return Boolean(window.opener);
};

const isModernIncontext = () => {
  return Boolean(window.xprops) && (isPopup() || isIframe());
};

const isVzeroIntegration = () => {
  const hasVzeroParam = /[?&]nolegacy=1/.test(window.location.search);

  return window.name === 'PPFrameRedirect' || hasVzeroParam;
};

const isLegacyIncontext = () => {
  const isIframeWindow = isIframe();
  const isPopupWindow = isPopup();
  const isVzeroIntegrationWindow = isVzeroIntegration();
  const windowName = window.name;
  const urlParams = window.location.search;
  const isXpropsPresent = Boolean(window.xprops);

  $logger.info('integration_type_decider_params', {
    isIframeWindow,
    isPopupWindow,
    isVzeroIntegrationWindow,
    isXpropsPresent,
    urlParams,
    windowName,
  });

  // Check for Braintree vzero first, before we hit any other integration check
  // Reason: window.name for vZero is "PPFrameRedirect". If we check
  // for legacy incontext flow first, then "PPFrame" substring check on
  // line 47 will return true and vZero integration will be treated as
  // legacy incontext integration (vzero also returns isPopup() as true)
  if (isXpropsPresent || isVzeroIntegrationWindow) {
    return false;
  }

  const hasLegacyWindowName = /PPFrame|xcomponent__ppcheckout/.test(windowName);
  const hasLegacyNameAndIsPopup = hasLegacyWindowName && isPopupWindow;

  const hasIncontextParam = /[?&]incontext=1/.test(urlParams);
  const hasIncontextParamOrIframe = hasIncontextParam || isIframeWindow;

  return hasLegacyNameAndIsPopup || hasIncontextParamOrIframe;
};

const isIncontext = () => {
  return isModernIncontext() || isLegacyIncontext();
};

/**
 * @function postToMerchantForOldIncontext
 * @param {string} msg
 * @returns {boolean}
 * @description old incontext integrations - send post message
 */
const postToMerchantForOldIncontext = returnUrl => {
  if (!isLegacyIncontext()) {
    return false;
  }

  try {
    const msg = JSON.stringify({
      operation: 'return_to_merchant',
      returnUrl,
      updateParent: true,
    });

    const isEdge = Boolean(window.navigator.userAgent.match(/edge/i));
    const isNotIE = Boolean(
      window.opener?.postMessage &&
        !window.navigator.userAgent.match(/msie|trident/i),
    );

    // If we are not in IE, attempt to send a postMessage
    if (isEdge || isNotIE) {
      $logger.info('old_incontext_postmessage');
      window.opener.postMessage(msg, '*');
      return true;
    }

    // Otherwise, attempt to send a message through the iframe bridge
    const bridge =
      window.opener?.frames?.length && window.opener?.frames?.PayPalBridge;

    if (bridge?.returnToParent) {
      $logger.info('old_incontext_bridgemessage');
      bridge.returnToParent(msg);
      return true;
    }
  } catch (err) {
    $logger.warn('old_incontext_postback_error', {
      error: err.stack || err.toString(),
    });
  }

  $logger.info('old_incontext_nopostback');

  return false;
};

export {
  isIframe,
  isIncontext,
  isPopup,
  isLegacyIncontext,
  isModernIncontext,
  postToMerchantForOldIncontext,
};
